import { ToggleGroup, ToggleGroupOption } from '@retail/components';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { ItemPriority } from '@retail/products/types';
import { useMemo } from 'react';
interface Props {
  selectedPriority: ItemPriority;
  setPriority: (prio: ItemPriority) => void;
  hideLabel?: boolean;
}

export function SupplierPriorityToggleGroup({ selectedPriority, setPriority, hideLabel }: Props) {
  const t = useMyAssortmentTFunction();

  const priorityOptions: ToggleGroupOption<ItemPriority.ZERO | ItemPriority.TEN>[] = useMemo(
    () => [
      { label: t('myAssortment.priority.mainPrioSupplier'), value: ItemPriority.TEN },
      { label: t('myAssortment.priority.underPrioSupplier'), value: ItemPriority.ZERO },
    ],
    [t]
  );
  return (
    <ToggleGroup
      label={hideLabel ? undefined : t('myAssortment.status.inAssortment')}
      labelVariant="body1"
      labelDirection="vertical"
      size="small"
      fullWidth
      options={priorityOptions}
      value={selectedPriority}
      onChange={setPriority}
    />
  );
}
